module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c3auT"))).then(() => parcelRequire('1iHdE'));